import axios from 'axios';

import { createErrorSnackbar } from 'components/Snackbar/Snackbar.saga';

import { apiErrorSnackbarMessages } from './api-error-snackbar.messages';

const RESIZE_OBSERVER_LOOP = /resizeobserver loop/i;
const CHUNK_LOAD_ERROR_NAME = 'ChunkLoadError';
const CHUNK_LOAD_ERROR_PATTERN = /loading chunk .+ failed/i;
const DOM_RECONCILIATION_ERROR_PATTERN =
  /failed to execute '(removechild|insertbefore)'|is not a child of this node|the object can not be found here/i;

export function isCanceledRequest(error) {
  return error?.code === 'ERR_CANCELED' || axios.isCancel(error);
}

export function isNetworkError(error) {
  if (isCanceledRequest(error)) return false;
  if (error?.code === 'ERR_NETWORK') return true;
  return !!error?.isAxiosError && !error.response;
}

export function isResizeObserverLoopError(error) {
  return typeof error?.message === 'string' && RESIZE_OBSERVER_LOOP.test(error.message);
}

export function isChunkLoadError(error) {
  return error?.name === CHUNK_LOAD_ERROR_NAME || CHUNK_LOAD_ERROR_PATTERN.test(error?.message ?? '');
}

export function isDomReconciliationError(error) {
  return typeof error?.message === 'string' && DOM_RECONCILIATION_ERROR_PATTERN.test(error.message);
}

let networkSnackbarPending = false;

export function clearNetworkErrorSnackbarLock() {
  networkSnackbarPending = false;
}

export function resetNetworkErrorSnackbarLockForTests() {
  networkSnackbarPending = false;
}

export function dispatchNetworkErrorSnackbar({ force = false } = {}) {
  if (typeof window === 'undefined' || !window.store) return;
  if (!force && networkSnackbarPending) return;
  networkSnackbarPending = true;
  window.store.dispatch(
    createErrorSnackbar(
      apiErrorSnackbarMessages.networkErrorTitle,
      {},
      { isLowStyle: true },
      apiErrorSnackbarMessages.networkErrorDescription
    )
  );
}
